<template>
  <v-container fluid>
    <!-- <v-breadcrumbs :items="items">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs> -->
        <div id="app " >
  <v-row>
          <v-col cols="11">
    <Breadcrumb class="row justify-content-center mt-4"/>
    </v-col>
    <v-col cols="1" v-if="showLoader">
        <LoaderProgress
      ></LoaderProgress>
    </v-col>
</v-row>    </div>
    <v-row>
      <v-col>
        <newFiltercomp style="margin-right: 5px !important" :filter_data="param" />
      </v-col>
    </v-row>
    <!-- <v-data-table
      ref="theDataTable"
      :headers="headersData"
      :items="operatorsData"
      :search="search"
      :items-per-page="5"
      class="elevation-1"
      @pagination="pagination = $event"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="50"
            offset-x
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=""
                outlined
                fab
                small
                color="#0C479D"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>icon-download</v-icon>
              </v-btn>
            </template>

            <v-card>
            
              <v-divider></v-divider>

              <v-list>
                <v-list-item>
                  <v-list-item-action>
                    <vue-json-to-csv
                      :json-data="dataDownload"
                      :csv-title="'Production Data'"
                    >
                      <v-btn color="indigo" dark style="">
                        CSV
                      </v-btn>
                    </vue-json-to-csv>

                   
                  </v-list-item-action>
                </v-list-item>

                <v-list-item>
                  <v-list-item-action>
                    <v-btn @click="createPDF" color="indigo" dark>PDF </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
        </v-toolbar>
      </template>

      
    </v-data-table> -->
    <div>
      <tableComponent v-bind:tabledataProp="TableData" v-if="show"/>
    </div>
  </v-container>
</template>
<script>
// import filterHeaderComp from "../components/filterHeaderComp.vue";
import tableComponent from '../components/tableComponent.vue';

import Breadcrumb from '../components/breadcrumbs.vue';
import LoaderProgress from "../components/progressLoader";
import newFiltercomp from '../components/newFiltercomp.vue';
import axios from "axios";
// import VueJsonToCsv from "vue-json-to-csv";
// import constants from "../constants";
import router from "../router";
// import jsPDF from "jspdf";
import "jspdf-autotable";
// const logo = require("../assets/trinitiimage.png");
export default {
  components: {  newFiltercomp, Breadcrumb, LoaderProgress,tableComponent},

  data() {
    return {
      show:false,
      TableData:{
        search:'',
        savingFilename:'Production Report',
        columnHeaders : [
        "Machine",
        "Product Code",
        "Production Start Time",
        "Production End Time",
        "Production Quantity",
        "Cycle Time",
        "Availability",
      ],
      pagination: {
        page: null,
        itemsPerPage: null,
        pageStart: null,
        pageStop: null,
        pageCount: null,
        itemsLength: null,
      },
      tempRow : [
            "machine_name",
            "product_code",
            "production_start_time",
            "production_end_time",
            "production_qty",
            "cycle_time" ,
            "availability" ,
          ],


      },
       param: {
      machine: true,
      time_period: true,
      check: false,
      aggfunc: false,
      date: false,
      date_2: false,
      time: false,
      time2: false,
      select_1: 1,

    },
      items: [
        {
          text: "Home",
          disabled: false,
          href: "/",
        },
           {
        text: "Report Menu",
        disabled: true,
        href: "/",
      },
        {
          text: "Production Report",
          disabled: true,
        },
      ],
      showWarning: false,
      showLoader: false,
      dataDownload: [],
      search: "",
      operatorsData: [],
      menu: false,
      headersData: [],
      pagination: {
        page: null,
        itemsPerPage: null,
        pageStart: null,
        pageStop: null,
        pageCount: null,
        itemsLength: null,
      },
    };
  },
  mounted() {},

  methods: {

            selected(crumb) {
      if (crumb === 'Home')
      {
                  router.push(`/${sessionStorage.getItem("route_first_option")}`);
      }
      console.log(crumb);
    },
    // createPDF() {
    //   let content = this.$refs["theDataTable"];
    //   console.log("pagination", this.pagination);
    //   let doc = new jsPDF("landscape");
    //   doc.text(14, 7.5, "Production Report");
    //    doc.addImage(
    //     this.getImgUrl1(this.$config.image_inside_pdf),
    //     "png",
    //     this.$config.first_dimension_separate_again,
    //     this.$config.second_dimension_separate,
    //     this.$config.third_dimension_separate,
    //     this.$config.fourth_dimension_separate_again
    //   );
    //   let columnHeaders = [
    //     "Machine",
    //     "Product Code",
    //     "Production Start Time",
    //     "Production End Time",
    //     "Production Quantity",
    //     "Cycle Time",
    //     "Availability",
    //   ];
    //   let rows = [];
    //   content.items.forEach((data, index) => {
    //     if (
    //       index >= this.pagination.pageStart &&
    //       index < this.pagination.pageStop
    //     ) {
    //       let tempRow = [
    //         data.machine_name || "",
    //         data.product_code || "",
    //         data.production_start_time || "",
    //         data.production_end_time || "",
    //         data.production_qty || "",
    //         data.cycle_time || "",
    //         data.availability || "",
    //       ];
    //       rows.push(tempRow);
    //     }
    //   });
    //   console.log("checkign temp row=>", rows);
    //   doc.setFontSize(9);
    //   doc.autoTable(columnHeaders, rows, { startY: 11.5 });
    //   let d = new Date();
    //   doc.save(
    //     `Production_Reports ${d.toISOString().slice(0, 10) +
    //       " " +
    //       d
    //         .toTimeString()
    //         .split("(")[0]
    //         .slice(0, -1)}.pdf`
    //   );
    // },

    intervalFetchData: function(machine_id, startDate, endDate) {
      this.machine_id_Selected = machine_id;
      this.start_date = startDate;
      this.end_date = endDate;
      console.log("machine id", machine_id);
      console.log(
        "selected start date",
        startDate,
        "selected end date",
        startDate
      );

      this.searchNew(this.machine_id_Selected, startDate, endDate);
    },
    searchNew: function(machine_id, startDate, endDate) {
      this.show =false
      this.start_date = startDate;
      this.end_date = endDate;
      this.machine_id_Selected = machine_id;
      console.log(
        "machine select",
        this.machine_id_Selected,
        "Done to say",
        machine_id
      );
      let params = "";
      if (this.start_date == "") {
        params = `?machine_id=${machine_id}`;
      } else {
        params = `?machine_id=${machine_id}&startdate=${this.start_date}&enddate=${this.end_date}`;
      }
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getProductionData${params}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.setGridData(config);
    },
    setGridData: function(config) {
      this.headersData = [
        {
          text: "Machine Name",
          value: "machine_name",
          sortable: true,
        },
        {
          text: "Product Code",
          value: "product_code",
sortable: true,
        },
        {
          text: "Production Start Time",
          value: "production_start_time",
sortable: true,        },
        {
          text: "Production End Time",
          value: "production_end_time",
sortable: true,        },
        {
          text: "Production Quantity",
          value: "production_qty",
sortable: true,        },
        {
          text: "Cycle Time",
          value: "cycle_time",
sortable: true,        },
        {
          text: "Availability",
          value: "availability",
sortable: true,        },
      ];
      this.TableData['headersData']=this.headersData


      this.showLoader = true;
      this.showWarning = false;
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          let _data = response.data.data;
          console.log("checkign resp", response.data.data);
          this.operatorsData = response.data.data;
          this.TableData['operatorsData']=this.operatorsData
          let result = [];
          for (let i in response.data) result.push([i, response.data[i]]);
          this.dataDownload = result[0][1];
          this.TableData['dataDownload']=this.dataDownload
          this.show= true
          this.item = _data;
          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            this.showWarning = true;
            this.item = [];
            console.log("axios error", error.message);
          }
        });
    },
  },
};
</script>
<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>